export const remapObjectToOneLevel = (obj: unknown, newObj: any = {}) => {
  Object.entries(obj).map((keyValue: any[]) => {
    if (keyValue[1]?.constructor.name === 'Object') {
      remapObjectToOneLevel(keyValue[1], newObj);
    } else {
      newObj[keyValue[0]] = keyValue[1];
    }
  });
  return newObj;
};
